import { memo } from 'react';

/**
 * EmptyState - Pure presentational component
 * Wrapped in React.memo to prevent unnecessary re-renders
 */
const EmptyState = memo(function EmptyState({ icon = '📭', title, message, action }) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">{icon}</div>
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-message">{message}</p>
      {action && (
        <button className="btn btn-primary" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
});

export default EmptyState;
